import { useReducer } from "react";
import biApi from "../../../../../../api/biApi";
import type { SmartViewWidget } from "../../../../../../api/types/dashboardsTypes.ts";
import type { TileReportConfigurationForRunning } from "../../../../../../api/types/svTypes.ts";
import DrillDownEntry from "../../../../reporting/sv/components/builder/common/drillDown/DrillDownEntry.tsx";
import useViewReportHandlers from "../../../../reporting/sv/components/viewer/common/hooks/useViewReportHandlers.ts";
import { initializeTileRunState, reducer } from "../../../../reporting/sv/components/viewer/storage/runState.ts";
import { isTileRunState } from "../../../../reporting/sv/components/viewer/storage/runStateUtils.ts";
import { BiCommonDataContextProvider } from "../../../../reporting/sv/contexts/BiCommonDataContextProvider.tsx";
import SmartViewWidgetWrapper from "../SmartViewWidgetWrapper";
import SmartViewTileWidgetViewer from "./SmartViewTileWidgetViewer";

interface Props {
  widget: SmartViewWidget;
  data: TileReportConfigurationForRunning;
}
const SmartViewTileContainer = ({ data, widget }: Props) => {
  const [runState, dispatchRunState] = useReducer(reducer, initializeTileRunState(data, widget.reportId));

  const { handleConditionUpdate, handleFieldUpdate, handleRefreshGrid } = useViewReportHandlers(dispatchRunState);

  if (!isTileRunState(runState)) {
    return null;
  }

  return (
    <BiCommonDataContextProvider
      reportType={runState.reportType}
      books={runState.books}
      isMultiBook={runState.isMultiBook}
      dataSetId={runState.dataSetId}
      dimensionsStructure={undefined}
      dimensions={runState.dimensions}
      editMode={false}
      conditions={runState.conditions}
      reportId={widget.reportId}
      refreshToken={runState.refreshToken}
      dimensionNames={runState.dimensionNames}
      measureNames={runState.measureNames}
      onConditionUpdate={handleConditionUpdate}
      onRefreshGrid={handleRefreshGrid}
      onFieldWithCustomConditionUpdate={handleFieldUpdate}
    >
      <SmartViewWidgetWrapper widget={widget} conditions={data.conditions}>
        <SmartViewTileWidgetViewer runState={runState} runReport={biApi.dashboardReports.runTileReport} />
      </SmartViewWidgetWrapper>
      <DrillDownEntry reportId={widget.reportId} />
    </BiCommonDataContextProvider>
  );
};

export default SmartViewTileContainer;
